import { useContext, useState } from "react";
import { Button, Flex, Heading, MHeader } from "@cisco/spaces-dash-lib-styleguide";
import { Login } from "@cisco/spaces-dash-lib-login";
import { I18nContext } from "../../contexts/i18nContext";
import CoverImage from "../../assets/images/login/banner_bg.jpg";
import { LogoComponent } from "../../components/header/login-page-header/login-page-header";
import { LoginModal } from "../../components/modals/login/login-modal";

export function SupportLoginPage(): JSX.Element {
  const i18n = useContext(I18nContext);

  const { t } = i18n || { t: (key: string) => key };

  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  const openLoginModal = () => {
    setIsLoginModalOpen(true);
  };

  const closeLoginModal = () => {
    setIsLoginModalOpen(false);
  };

  return (
    <Flex
      style={{
        width: "100%",
        height: "100vh",
        background: `url(${CoverImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center 0px",
        backgroundRepeat: "no-repeat"
      }}
      direction="vertical"
    >
      <LoginModal isOpen={isLoginModalOpen} closeModal={closeLoginModal}>
        <Login isSupportLogin i18n={i18n} />
      </LoginModal>
      <MHeader style={{ background: "transparent", color: "#58585b" }} logo={<LogoComponent />} />
      <Flex style={{ width: "100%", height: "100%" }} justify="center" align="center" direction="vertical" gap={24}>
        <Heading size="primary" style={{ fontSize: "4rem", color: "#fff" }}>
          {t("auth.support-login-sso.cisco-spaces-partner-text", {
            ns: "spaces-dash-app-partners-login"
          })}
        </Heading>
        <Heading size="sub-section" style={{ color: "#fff", marginBottom: "8px" }}>
          {t("auth.login.login-partner-base.be-part-of-cisco-spaces-text", {
            ns: "spaces-dash-app-partners-login"
          })}
        </Heading>
        <Button.Group>
          <Button kind="secondary" onClick={openLoginModal}>
            {t("auth.activate-appuser.login-text", {
              ns: "spaces-dash-app-partners-login"
            })}
          </Button>
        </Button.Group>
      </Flex>
    </Flex>
  );
}
